import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import $ from "jquery";

import { allAwards } from "../AwardsData";   // GLOBAL SEARCH IMPORT

export function Navbar() {
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  // Handle typing in search
  const handleInput = (value) => {
    setSearch(value);

    if (!value.trim()) {
      setSuggestions([]);
      return;
    }

    // global search across ALL awards
    const results = allAwards.filter((item) =>
      item?.htext?.toLowerCase()?.includes(value.toLowerCase())
    );

    setSuggestions(results.slice(0, 6)); // max 6 suggestions
  };

  // On enter or search button click
  const handleSearch = (e) => {
    e.preventDefault();
    if (!search.trim()) return;
    navigate(`/search?q=${encodeURIComponent(search.trim())}`);
    setSuggestions([]);
  };

  // On suggestion click
  const handleSelect = (name) => {
    navigate(`/search?q=${encodeURIComponent(name)}`);
    setSearch(name);
    setSuggestions([]);
  };

  // Navbar dropdown toggle
  useEffect(() => {
    $("#navbar-toggler").click(() => $("#navbarSupportedContent").slideToggle());
  }, []);

  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid">

        <Link className="navbar-brand" to="/">Indian Highest Awards</Link>

        <button className="navbar-toggler" id="navbar-toggler">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
  <li><Link className="nav-link active" to="/">Home</Link></li>
  <li><Link className="nav-link" to="/quiz">Quiz</Link></li>  {/* <-- Added */}
  
  <li className="nav-item dropdown">
    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Categories</a>
    <ul className="dropdown-menu">
      <li><Link className="dropdown-item" to="/arts">Arts Awards</Link></li>
      <li><Link className="dropdown-item" to="/science">Science Awards</Link></li>
      <li><Link className="dropdown-item" to="/literature">Literature Awards</Link></li>
      <li><Link className="dropdown-item" to="/sports">Sports Awards</Link></li>
      <li><Link className="dropdown-item" to="/social">Social Awards</Link></li>
      <li><Link className="dropdown-item" to="/business">Business Awards</Link></li>
      <li><Link className="dropdown-item" to="/state">State Awards</Link></li>
      <li><Link className="dropdown-item" to="/international">International Awards</Link></li>
    </ul>
  </li>
</ul>


          {/* SEARCH BOX */}
          <div style={{ position: "relative" }}>
            <form className="d-flex" onSubmit={handleSearch}>
              <input
                className="form-control me-2"
                type="text"
                placeholder="Search awards..."
                value={search}
                onChange={(e) => handleInput(e.target.value)}
              />
              <button className="btn btn-outline-success" type="submit">Search</button>
            </form>

            {/* SUGGESTIONS DROPDOWN */}
            {suggestions.length > 0 && (
              <ul
                style={{
                  position: "absolute",
                  background: "#fff",
                  width: "100%",
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  top: "42px",
                  zIndex: 1000,
                }}
              >
                {suggestions.map((item, i) => (
                  <li
                    key={i}
                    style={{ padding: "8px 12px", cursor: "pointer" }}
                    onMouseDown={() => handleSelect(item.htext)}
                  >
                    {item.htext}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
